import { AccountHeaderType } from "pages/Setup/Account/LinkAccount/types";

export const dataAccountLinkPurchase: AccountHeaderType[] = [
    {
        Header: "PURCHASE LINKED ACCOUNT",
        LinkAccount: [
            {
                linked_account_id: 1,
                linked_account_code: "LA07",
                linked_account_name: "Purchase Linked Account",
                description: "Liability Account for Tracking AP",
                account_coa: "2"
            },
            {
                linked_account_id: 2,
                linked_account_code: "LA08",
                linked_account_name: "Purchase Linked Account",
                description: "Asset Bank Account for Vendor Payable",
                account_coa: "1"
            },
            {
                linked_account_id: 3,
                linked_account_code: "LA09",
                linked_account_name: "Purchase Linked Account",
                description: "Asset Account for Supplier Deposit",
                account_coa: "1"
            },
            {
                linked_account_id: 6,
                linked_account_code: "LA10",
                linked_account_name: "Purchase Linked Account",
                description: "Account for Damaged and Losed",
                account_coa: "1"
            },
            {
                linked_account_id: 7,
                linked_account_code: "LA11",
                linked_account_name: "Purchase Linked Account",
                description: "Asset Account for Reject",
                account_coa: "1"
            },
            {
                linked_account_id: 4,
                linked_account_code: "TAXP",
                linked_account_name: "Purchase Linked Account",
                description: "Liability Tax Paid",
                account_coa: "2"
            },
            {
                linked_account_id: 5,
                linked_account_code: "BA01",
                linked_account_name: "Purchase Linked Account",
                description: "COGS Account for Freight On Bill",
                account_coa: "5"
            },

        ]
    }
]